import { Wrapper, ContentTypeRender } from "nystem-components";

const StyleView = ({ model, path }) => {
  const { className, renderAs, item, title } = model;

  return (
    <Wrapper className={className} renderAs={renderAs} title={title}>
      <ContentTypeRender path={path} items={item} />
    </Wrapper>
  );
};

export default StyleView;
